export interface NavItem {
  name: string;
  path: string;
  idPrefix: string;
  external?: boolean;
  mobileOnly?: boolean;
}

export const headerId = 'header';
